import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import '../style/App.css';

//required Props receive and/or pass back to parent:
// - this.props.handleEmail(value) to pass up values to state (for sending to backend, passed up)
// - this.props.email (content of TextField, pass up and down)

class ContactEmail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: ''
    }
    this.handleEmail = this.handleEmail.bind(this);
  }

  handleEmail(value) {
    this.props.handleEmail(value);
  }

  componentDidMount() {
    if (this.props.email) {
      console.log('email: ', this.props.email)
      this.setState({
        email: this.props.email
      })
    }
  }

  render() {
    return (
      <div className='contactFormFieldHolder'>
        <TextField
          onChange={(e) => this.handleEmail(e.target.value)}
          variant="outlined"
          id="email-form"
          label="email"
          value={this.props.email}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgb(125, 120, 120)'
            },
            '& .MuiInputLabel-root': {
              color: 'rgb(125, 120, 120)'
            }
          }}
        />
      </div>
    )
  }

}

export default ContactEmail;
